import { LocalDate } from '../../../utilities/local-date';
import { timeInMinutes } from './time-in-minutes';

/**
 * Takes a list of periods, a list of period type names and a day
 * Returns a list of minute ranges (represented by start minutes and end minutes) for periods that matches types and day
 */
export function periodMinutesForDay(periods, types, confirmed, day) {
  const result: { start: number; end: number }[] = [];
  const validPeriods = periods.filter((period) => {
    if (period.confirmed || !confirmed) {
      return period;
    }
  });
  validPeriods.forEach((period) => {
    const startDate = LocalDate.fromString(period.start);
    const endDate = LocalDate.fromString(period.end);
    if (types.includes(period.type) && startDate.isSameOrBefore(day) && endDate.isSameOrAfter(day)) {
      let start = 0;
      if (startDate.isSame(day) && period.startTime) {
        start = timeInMinutes(period.startTime);
      }
      let end = 1440;
      if (endDate.isSame(day) && period.endTime) {
        end = timeInMinutes(period.endTime);
      }
      result.push({
        start: start,
        end: end,
      });
    }
  });
  return result;
}
